/**
 * @deprecated
 * TODO: Replace this with @elephant-healtcare/migrating-mfe-basename
 */
export default function () {
  return window.location.pathname.startsWith('/shell') ? '/shell' : '/';
}
